<template>
  <div class="content content-fixed">
    <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">
      <div
        class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
      >
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
              <li class="breadcrumb-item"><a href="#">Тавтай морил</a></li>
              <li class="breadcrumb-item active" aria-current="page">
                Хяналтын самбар
              </li>
            </ol>
          </nav>
          <h4 class="mg-b-0 tx-spacing--1">
            Төслийн болон шинжээчийн бүртгэл, мэдүүлгийн систем
          </h4>
        </div>
        <div class="d-none d-md-block">
          <a href="/#/stf/apply/561/0/0/0/0/0" class="btn btn-sm pd-x-15 btn-primary btn-uppercase tx-white">
            <feather type="menu"></feather> Эхлэл
          </a>
          <!-- <router-link to="/tr/travel/557/0/0/0/0/0" class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5">
            <feather type="menu"></feather> Аялал
          </router-link> -->
        </div>
      </div>

      <div class="row row-xs">
          <penalty-paid-data></penalty-paid-data>

          <div class="col-lg-4 mg-t-10">
            <penalty-group-by-type></penalty-group-by-type>

            

          </div>

          <div class="col-lg-8 mg-t-10">
            <div class="col-12 pd-0">
              <div class="row no-gutter">
                <div class="col-lg-6 pd-t-0">
                  <terminals bd="" mgt=""></terminals>
                </div>
                <div class="col-lg-6 pd-t-0">
                  <accident bd="" mgt=""></accident>
                </div>
              </div>
            </div>

            <!-- <map-asset></map-asset> -->

            
          </div>
        </div>

        <div class="row row-xs">
          <div class="col-lg-3 mg-t-10">
            <vehicle-count title="Төслийн оролцогчид зэргээр" url="projectEdu/ProjectMemberGroupByDegree"></vehicle-count>
          </div>
          <div class="col-lg-3 mg-t-10">
            <vehicle-count title="Оролцох хэлбэрээр" url="projectEdu/ProjectMemberGroupByRole"></vehicle-count>
          </div>
          <div class="col-lg-6 mg-t-10">
            <oyunii-umch title="Гарах оюуны өмчийн мэдээлэл"></oyunii-umch>
          </div>
        </div>

      
    </div>

  </div>
</template>
<script>
import { mapActions } from "vuex";
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { getTypeTreeData } from "@/api/type";

var _ = require("lodash");
const moment = require("moment");

export default {
  components: {
    chartMixed: () => ({
      component: import("@/views/home/apps/mori/charts/mixed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    chartMixed1: () => ({
      component: import("@/views/home/apps/mori/charts/mixed1.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDialog: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 15000,
    }),


    penaltyGroupByType: () => ({
      component: import(
        "@/views/home/apps/stf/components/penaltyGroupByType.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    penaltyPaidData: () => ({
      component: import("@/views/home/apps/stf/components/penaltyPaidData.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mapAsset: () => ({
      component: import("@/views/home/apps/stf/components/mapAsset.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    terminals: () => ({
      component: import("@/views/home/apps/stf/components/terminals.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    accident: () => ({
      component: import("@/views/home/apps/stf/components/accident.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    vehicleCount: () => ({
      component: import("@/views/home/apps/stf/components/btm1.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),

    oyuniiUmch: () => ({
      component: import("@/views/home/apps/stf/components/btm2.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      taskDialogDtl: {
        show: false,
        id: 0,
        key: 0,
      },

      taskDtl: {
        obj: {
          task: null,
          defaultAttachmentUrl: null,
          taskDesc: null,
        },
        mdl: false,
      },
    };
  },

  mounted() {

    let _obj = this.$store.state.app.mainLayoutConfig;
    //console.log('obj', _obj)
    _obj.aside = false;
    _obj.header = 201;
    _obj.expanded = false;
    this.handleMainLayoutConfig(_obj);


  },
  methods: {
    ...mapActions(["handleLoading", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    showTask(e) {
      //alert(e)
      // let curu= this.planDriver.filter(x=>x.userTaskId==e.id && x.planMonth==month);
      // if(curu.length){
      this.taskDialogDtl.id = e.id;
      this.taskDialogDtl.key++;
      this.taskDialogDtl.show = true;
      //}
    },
    showTaskDtl(e, month) {
      //alert(e)
      let curu = this.planDriver.filter(
        (x) => x.userTaskId == e.id && x.planMonth == month
      );
      if (curu.length) {
        this.taskDialogDtl.id = curu[0].id;
        this.taskDialogDtl.key++;
        this.taskDialogDtl.show = true;
      }
    },
    taskPosted(e) {
      //s('e', e);
      //this.mode=0;
      //this.filterByTrainer(e.prms.fillAfter.organizationTaskId);
      this.getTrDriverTravelPlan(this.trainerCurId, this.curYear);
      this.editClosed();
      this.getInTimeTravelList();
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
  },
};
</script>
<style lang="less">
  .trdrp{
    .dropdown-toggle{
      margin: 0;
      padding: 0 5px;
      &::after{
        display: none;
      }
    }
  }
</style>